// src/utils/analytics.ts
// to track google analytics when we use react router
// tag id is the same as in index.html, and coming from google analytics

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
    __gtag_initialized__?: boolean;
  }
}

export const initGA = (): void => {
  if (process.env.REACT_APP_ENV !== 'production') return;

  if (window.__gtag_initialized__) return;
  window.__gtag_initialized__ = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtag/js?id=G-M1Y7G604FB';
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = (...args: unknown[]) => {
    window.dataLayer.push(args);
  };

  window.gtag('js', new Date());
  window.gtag('config', 'G-M1Y7G604FB');
};

  